import React, { Component } from 'react'

export default class Tag extends Component {
    render() {
        const { children, onClick = () => {}, style = {}, bold = false } = this.props;
        const newStyle = {...styles.tag, ...style, fontWeight: bold ? "bold" : ""};
        return (
            <div style={newStyle} onClick={() => {onClick && onClick()}}>
                {children}
            </div>
        )
    }
}

const styles = {
    tag: {
        background: "lightskyblue",
        borderRadius: "25px",
        padding: ".5rem 1rem",
        marginTop: ".35rem",
        //fontWeight: "bold",
        cursor: "pointer",
    }
}